<div class="control-news-container">
  <div class="container py-5">
    <!-- Header Section -->
    <div class="header-section mb-5 text-center" data-aos="fade-down">
      <h1 class="page-title">
        <i class="fa-solid fa-newspaper me-2"></i>
        التحكم في الأخبار
      </h1>
      <p class="page-subtitle">إدارة وتعديل الأخبار بسهولة</p>
    </div>

    <!-- Error/Success Messages -->
    <div class="alert-messages mb-4" *ngIf="errorMessage || successMessage">
      <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="errorMessage">
        <i class="fa-solid fa-circle-exclamation me-2"></i>
        {{ errorMessage }}
        <button type="button" class="btn-close" (click)="errorMessage = ''" aria-label="Close"></button>
      </div>
      <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="successMessage">
        <i class="fa-solid fa-circle-check me-2"></i>
        {{ successMessage }}
        <button type="button" class="btn-close" (click)="successMessage = ''" aria-label="Close"></button>
      </div>
    </div>

    <!-- Form Section -->
    <div class="form-section mb-5" data-aos="fade-up">
      <div class="card form-card shadow-lg">
        <div class="card-header">
          <h3 class="mb-0">
            <i class="fa-solid fa-plus-circle mx-2"></i>
            {{ isEditing ? 'تعديل الخبر' : 'إضافة خبر جديد' }}
          </h3>
        </div>
        <div class="card-body">
          <form [formGroup]="newsForm" (ngSubmit)="onSubmit()">
            <div class="row g-4">
              <!-- Title Field -->
              <div class="col-12">
                <label for="title" class="form-label">
                  <i class="fa-solid fa-heading me-2"></i>
                  عنوان الخبر
                </label>
                <input 
                  type="text" 
                  id="title"
                  class="form-control" 
                  placeholder="أدخل عنوان الخبر"
                  formControlName="title"
                  [class.is-invalid]="newsForm.get('title')?.touched && newsForm.get('title')?.invalid"
                />
                <div class="invalid-feedback" *ngIf="newsForm.get('title')?.touched && newsForm.get('title')?.invalid">
                  عنوان الخبر مطلوب
                </div>
              </div>

              <!-- Article Field -->
              <div class="col-12">
                <label for="article" class="form-label">
                  <i class="fa-solid fa-file-lines me-2"></i>
                  المقال
                </label>
                <textarea 
                  id="article"
                  class="form-control" 
                  placeholder="أدخل نص المقال"
                  rows="6"
                  formControlName="article"
                  [class.is-invalid]="newsForm.get('article')?.touched && newsForm.get('article')?.invalid"
                ></textarea>
                <div class="invalid-feedback" *ngIf="newsForm.get('article')?.touched && newsForm.get('article')?.invalid">
                  المقال مطلوب
                </div>
              </div>

              <!-- Image Upload Field -->
              <div class="col-md-6">
                <label for="image" class="form-label">
                  <i class="fa-solid fa-image me-2"></i>
                  صورة الخبر
                </label>
                <div class="image-upload-wrapper">
                  <input 
                    type="file" 
                    id="image"
                    class="form-control file-input" 
                    accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                    (change)="onFileSelected($event)"
                    [class.is-invalid]="newsForm.get('image')?.touched && newsForm.get('image')?.invalid"
                  />
                  <small class="form-text text-muted d-block mt-2">
                    <i class="fa-solid fa-info-circle me-1"></i>
                    الصيغ المدعومة: JPEG, PNG, GIF, WebP (حجم أقصى: 5 ميجابايت)
                  </small>
                  <div class="invalid-feedback" *ngIf="newsForm.get('image')?.touched && newsForm.get('image')?.invalid">
                    الصورة مطلوبة
                  </div>
                </div>

                <!-- Image Preview -->
                <div class="image-preview-container mt-3" *ngIf="imagePreview">
                  <div class="preview-wrapper">
                    <img [src]="imagePreview" alt="Preview" class="preview-image" />
                    <button 
                      type="button" 
                      class="btn-remove-image" 
                      (click)="removeImage()"
                      title="إزالة الصورة"
                    >
                      <i class="fa-solid fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Category Field -->
              <div class="col-md-3">
                <label for="category" class="form-label">
                  <i class="fa-solid fa-tags me-2"></i>
                  القسم
                </label>
                <select 
                  id="category"
                  class="form-select" 
                  formControlName="category"
                  [class.is-invalid]="newsForm.get('category')?.touched && newsForm.get('category')?.invalid"
                >
                  <option value="" disabled selected>اختر القسم</option>
                  @for (category of categories; track $index) {
                    <option
                    [value]="category.value"
                    [selected]="category.value === newsForm.get('category')?.value"
                    >
                    {{ category.label }}
                  </option>
                  }
                </select>
                <div class="invalid-feedback" *ngIf="newsForm.get('category')?.touched && newsForm.get('category')?.invalid">
                  يجب اختيار قسم
                </div>
              </div>

              <!-- editor Field -->
             <div class="col-md-3">
              <label for="editor" class="form-label">
                <i class="fa-solid fa-user-pen me-2"></i>
                المحرر
              </label>
              <input 
                type="text" 
                id="editor"
                class="form-control" 
                placeholder="اسم المحرر"
                formControlName="editor"
              />
            </div>

            </div>

            <!-- Form Actions -->
            <div class="form-actions mt-4 d-flex gap-3 justify-content-end">
              <button 
                type="button" 
                class="btn btn-cancel" 
                *ngIf="isEditing" 
                (click)="cancelEdit()"
              >
                <i class="fa-solid fa-times me-2"></i>
                إلغاء
              </button>
              <button 
                type="submit" 
                class="btn btn-submit"
                [disabled]="newsForm.invalid || loading"
              >
                <ng-container *ngIf="!loading">
                  <i class="fa-solid me-2" [class.fa-save]="isEditing" [class.fa-plus]="!isEditing"></i>
                  {{ isEditing ? 'حفظ التعديلات' : 'إضافة الخبر' }}
                </ng-container>
                <ng-container *ngIf="loading">
                  <i class="fa-solid fa-circle-notch fa-spin me-2"></i>
                  {{ isEditing ? 'جاري حفظ التعديلات...' : 'جاري إضافة الخبر...' }}
                </ng-container>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- News List Section -->
    <div class="news-list-section" data-aos="fade-up">
      <div class="list-header mb-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
        <h2 class="list-title mb-0">
          <i class="fa-solid fa-list me-2"></i>
          قائمة الأخبار ({{ filteredNews.length }} / {{ newsList.length }})
        </h2>

        <!-- Category Filter -->
        <div class="filter-wrapper" *ngIf="availableCategories.length > 0">
          <label for="categoryFilter" class="filter-label">
            <i class="fa-solid fa-filter me-2"></i>
            تصفية حسب القسم
          </label>
          <div class="select-wrapper">
            <select 
              id="categoryFilter"
              class="category-select"
              [(ngModel)]="selectedCategory"
              (ngModelChange)="onCategoryFilterChange()"
            >
              <option value="all">عرض جميع الأخبار ({{ newsList.length }})</option>
              <option *ngFor="let category of availableCategories" [value]="category">
                {{ category }} ({{ getCategoryCount(category) }})
              </option>
            </select>
            <i class="fa-solid fa-chevron-down select-icon"></i>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div class="text-center my-5" *ngIf="loading">
        <app-loading></app-loading>
      </div>

      <!-- Empty State -->
      <div class="empty-state text-center py-5" *ngIf="!loading && newsList.length === 0">
        <i class="fa-solid fa-inbox empty-icon"></i>
        <p class="empty-text">لا توجد أخبار متاحة حالياً</p>
      </div>

      <!-- No Results for Filter -->
      <div class="empty-state text-center py-5" *ngIf="!loading && filteredNews.length === 0 && newsList.length > 0">
        <i class="fa-solid fa-filter-circle-xmark empty-icon"></i>
        <p class="empty-text">لا توجد أخبار في هذا القسم</p>
        <button class="btn-reset-filter" (click)="selectedCategory = 'all'; onCategoryFilterChange()">
          <i class="fa-solid fa-rotate-right mx-2"></i>
          عرض جميع الأخبار
        </button>
      </div>

      <!-- News Cards Grid -->
      <div class="row g-4" *ngIf="!loading && filteredNews.length > 0">
        <div class="col-lg-6 col-xl-4" *ngFor="let item of filteredNews" data-aos="zoom-in">
          <div class="card news-card h-100 shadow">
            <div class="news-image-wrapper">
              <img [src]="item.image" class="news-image" [alt]="item.title" />
              <span class="category-badge">{{ item.category }}</span>
            </div>
            <div class="card-body">
              <h5 class="card-title">{{ item.title }}</h5>
              <p class="card-text news-preview">{{ item.article | slice:0:100 }}...</p>
              <div class="news-meta">
                <small>
                  <i class="fa-solid fa-clock mx-1"></i>
                  {{ item.createdAt | date:'medium' }}
                </small>
              </div>
            </div>
            <div class="card-footer">
              <div class="action-buttons d-flex gap-2">
                <button 
                  class="btn btn-edit flex-fill"
                  title="عرض"
                  [routerLink]="['/news', item.id]"
                >
                  <i class="fa-solid fa-eye mx-2"></i>
                  عرض
                </button>
                <button 
                  class="btn btn-edit flex-fill" 
                  (click)="editNews(item)"
                  title="تعديل"
                >
                  <i class="fa-solid fa-edit mx-2"></i>
                  تعديل
                </button>
                <button 
                  class="btn btn-delete flex-fill" 
                  (click)="deleteNews(item.id!)"
                  title="حذف"
                >
                  <i class="fa-solid fa-trash mx-2"></i>
                  حذف
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  